<template>
  <div>
    <div class="app-header1 header py-1 d-flex">
      <div class="container-fluid">
        <div class="d-flex">
          <router-link class="header-brand" style="margin-top: 5px" to="/">
            <span>{{ config.website.title.toUpperCase() }}</span>
            <!-- <img
              src="../../../.pagenify/assets/logo.png"
              class="header-brand-img"
              alt="Claylist logo"
            />-->
          </router-link>

          <a
            aria-label="Hide Sidebar"
            class="app-sidebar__toggle"
            data-toggle="sidebar"
            href="#"
          ></a>
          <div class="d-flex order-lg-2 ml-auto">
            <div class="dropdown d-none d-md-flex">
              <app-button
                label="Publish Website"
                style="height:40px; margin-top:5px"
                icon="paper-plane"
                @click="onClickPublish"
              />
            </div>
            <div class="dropdown d-none d-md-flex">
              <a class="nav-link icon full-screen-link">
                <i class="fe fe-maximize-2" id="fullscreen-button"></i>
              </a>
            </div>

            <div class="dropdown">
              <a
                href="#"
                class="nav-link pr-0 leading-none user-img"
                data-toggle="dropdown"
              >
                <img
                  src="../../../.pagenify/assets/profile-photo.jpg"
                  alt="profile-img"
                  class="avatar avatar-md brround"
                />
              </a>

              <div
                class="dropdown-menu dropdown-menu-right dropdown-menu-arrow"
              >
                <router-link
                  class="dropdown-item"
                  :to="{ name: 'accountSettings' }"
                >
                  <i class="dropdown-icon icon icon-settings"></i> Account
                  Settings
                </router-link>
                <a class="dropdown-item" @click="onLogout">
                  <i class="dropdown-icon icon icon-power"></i> Log out
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Sidebar menu-->
    <div class="app-sidebar__overlay" data-toggle="sidebar"></div>
    <aside class="app-sidebar doc-sidebar">
      <ul class="side-menu">
        <div v-for="menuItem in menuItems" :key="menuItem.name">
          <li v-if="!menuItem.childNames">
            <router-link
              class="side-menu__item"
              :class="{ active: isMenuItemActive(menuItem.name) }"
              data-toggle="slide"
              :to="{ name: menuItem.name }"
            >
              <i :class="`side-menu__icon fa fa-${menuItem.icon}`"></i>
              <span class="side-menu__label">{{ menuItem.title }}</span>
            </router-link>
          </li>

          <li v-else class="slide">
            <a
              class="side-menu__item"
              :class="{ active: isMenuItemActive(menuItem.name, true) }"
              data-toggle="slide"
              href="#"
            >
              <i :class="`side-menu__icon fa fa-${menuItem.icon}`"></i>
              <span class="side-menu__label">{{ menuItem.title }}</span>
              <i class="angle fa fa-angle-right"></i>
            </a>
            <ul class="slide-menu">
              <div v-for="child in menuItem.childs" :key="child.name">
                <li>
                  <router-link
                    class="slide-item"
                    :class="{ active: isMenuItemActive(child.name) }"
                    :to="{ name: child.name }"
                    >{{ child.title }}</router-link
                  >
                </li>
              </div>
            </ul>
          </li>
        </div>
      </ul>

      <!-- <div class="app-sidebar-footer">
        <a href="emailservices.html">
          <span class="fa fa-envelope" aria-hidden="true"></span>
        </a>
        <a href="profile.html">
          <span class="fa fa-user" aria-hidden="true"></span>
        </a>
        <a href="editprofile.html">
          <span class="fa fa-cog" aria-hidden="true"></span>
        </a>
        <a href="login.html">
          <span class="fa fa-sign-in" aria-hidden="true"></span>
        </a>
        <a href="chat.html">
          <span class="fa fa-comment" aria-hidden="true"></span>
        </a>
      </div>-->
    </aside>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import ToastService from '@/services/toast.service'
import config from '../../../.pagenify/config'

export default {
  data () {
    return {
      config: config,
      menuItems: [],
      selectedMenuItemName: null
    }
  },
  computed: { ...mapGetters(['user', 'isAuthenticated']) },
  mounted () {
    this.menuItems = config.content.map(item => {
      const { name, title, icon } = item
      return { name, title, icon }
    })
  },
  methods: {
    onLogout () {
      this.$store
        .dispatch('logout')
        .then(() => this.$router.push({ name: 'login' }))
    },
    isMenuItemActive (menuItemName, hasChild = false) {
      let hasSelectedChildItem = false
      if (hasChild) {
        const filteredMenuItems = this.menuItems.filter(menuItem => {
          return (
            menuItemName === menuItem.name &&
            menuItem.childNames.includes(this.$route.name)
          )
        })
        hasSelectedChildItem = filteredMenuItems.length > 0
      }

      return this.$route.name === menuItemName || hasSelectedChildItem
    },
    async onClickPublish () {
      await this.$http.post('https://api.netlify.com/build_hooks/5f79f7adb71464cb1dcbe15c')
      ToastService.success(this.$t('messages.publishSuccessMessage'))
    }
  }
}
</script>
